import 'react-toastify/dist/ReactToastify.css'

import { GlobalStyles, IconButton, useTheme } from '@mui/material'
import { IconCross } from 'assets/icons'
import { Slide, ToastContainer as ToastifyContainer } from 'react-toastify'

export const ToastContainer = () => {
  const theme = useTheme()

  return (
    <>
      <GlobalStyles
        styles={{
          '.Toastify__toast-body': {
            alignItems: 'self-start',
          },

          '.Toastify__toast': {
            '&::after': {
              content: '""',
              position: 'absolute',
              top: 6,
              left: 4,
              bottom: 6,
              width: '4px',
              borderRadius: '12px',
            },
          },

          '.Toastify__toast--info': {
            '&::after': {
              background: theme.palette.info.main,
            },
          },

          '.Toastify__toast--success': {
            '&::after': {
              background: theme.palette.success.main,
            },
          },

          '.Toastify__toast--warning': {
            '&::after': {
              background: theme.palette.warning.main,
            },
          },

          '.Toastify__toast--error': {
            background: theme.palette.error.light,

            '&::after': {
              background: theme.palette.error.main,
            },
          },
        }}
      />
      <ToastifyContainer
        autoClose={3000}
        transition={Slide}
        closeOnClick={false}
        position="bottom-right"
        hideProgressBar
        newestOnTop
        pauseOnFocusLoss
        pauseOnHover
        icon={false}
        closeButton={({ closeToast }) => (
          <IconButton onClick={closeToast}>
            <IconCross
              sx={{
                p: 0,
                height: '16px',
                width: '16px',
                position: 'absolute',
                top: '6px',
                right: '4px',
              }}
            />
          </IconButton>
        )}
        style={{
          width: 416,
          zIndex: theme.zIndex.snackbar,
        }}
        toastStyle={{
          background: 'fff',
          boxShadow:
            '0px 2px 1px rgba(0, 0, 0, 0.05), 0px 0px 1px rgba(0, 0, 0, 0.25)',
          borderRadius: '8px',
          paddingTop: '8px',
          paddingBottom: '8px',
          paddingRight: '4px',
          paddingLeft: '10px',
        }}
      />
    </>
  )
}
